import {
  Alert,
  Box,
  Button,
  Snackbar,
  Typography,
} from '@mui/material'
import { ReactElement, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { loadStripe } from '@stripe/stripe-js'
import { LaunchIcon } from 'src/v3/core/icons'
import useSession from 'src/authentication/hooks/use-session'

let stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY ?? '')

export default (): ReactElement => {
  let navigate = useNavigate()
  let session = useSession()

  let [successMessage, setSuccessMessage] = useState<string>('')
  let [errorMessage, setErrorMessage] = useState<string>('')

  useEffect(() => {
    if (!stripePromise) { return }

    stripePromise.then(async (stripe) => {
      if (stripe) {
        let url = new URL(window.location.toString())
        let clientSecret = url.searchParams.get('payment_intent_client_secret')
        let { error, paymentIntent } = await stripe.retrievePaymentIntent(clientSecret || '')

        if (error) {
          setErrorMessage(error.message || 'Payment Failed')
        } else {
          setSuccessMessage(`Payment ${paymentIntent?.status}`)
        }
      }
    })
  }, [stripePromise])

  let isBoundtree =
    session?.boundTreeStatus === 'subscribed' ||
    session?.boundTreeStatus === 'limited'

  return (
    <Box sx={{ backgroundColor: 'black' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mt: 1,
        }}
      >
        <Box sx={{ width: isBoundtree ? 300 : 200 }}>
          <img
            style={{ width: '100%', height: 'auto' }}
            src={isBoundtree ? '/btlogo.png' : '/logo.svg'}
          />
        </Box>
      </Box>
      <Box
        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
      >
        <Typography sx={{ my: 1 }}>
          Your subscription is a success! Thank you for choosing FOAMfrat Studio!
        </Typography>
        <Typography sx={{ mb: 2 }}>
          Click below to start or to register if you haven't already.
        </Typography>
        <Button
          variant="contained"
          startIcon={<LaunchIcon />}
          onClick={() => navigate('/self-paced')}
        >
          Return to Home Page
        </Button>
      </Box>
      <Snackbar open={!!successMessage} onClose={() => setSuccessMessage('')}>
        <Alert
          variant="filled"
          onClose={() => setSuccessMessage('')}
          severity="success"
        >
          {successMessage}
        </Alert>
      </Snackbar>
      <Snackbar open={!!errorMessage} onClose={() => setErrorMessage('')}>
        <Alert
          variant="filled"
          onClose={() => setErrorMessage('')}
          severity="error"
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </Box>
  )
}
